import { AppPage } from 'common/Layout';
import { ScheduleConfiguration } from 'features/schedule-configuration';
import { useScheduleConfigurationPage } from './use-schedule-configuration-page';

export const ScheduleConfigurationPage = () => {
  const { breadcrumbsLoading, breadcrumbs } = useScheduleConfigurationPage();

  return (
    <AppPage
      breadcrumbs={{
        items: breadcrumbs,
        loading: breadcrumbsLoading,
      }}
      documentTitle={'Настройка конфигурации'}
    >
      <ScheduleConfiguration />
    </AppPage>
  );
};
